import React from 'react';
import { View, TouchableOpacity, StyleSheet, Text } from 'react-native';
import { Color, CommonProperties } from '../styles';
import Icon from './Icon';
import { scale } from '../utils/scale.utils';
import BaseText from './BaseText';

export const FileButton = ({
  fileName,
  removeReceipt,
  handlePress,
  setWidth = true,
  isAddReceipt = false,
  textColor = Color.black,
  isEditable = true,
}) => {
  return (
    <TouchableOpacity onPress={handlePress}>
      {isAddReceipt ? (
        <View
          style={[
            styles.fileButtonContainer,
            setWidth && { width: '40%' },
            styles.addReceiptButtonContainer,
          ]}
        >
          <BaseText style={[styles.fileName, { color: Color.primary }]}>{fileName}</BaseText>
        </View>
      ) : (
        <View
          style={[
            styles.fileButtonContainer,
            setWidth && { width: '40%' },
            { backgroundColor: Color.lightgray },
          ]}
        >
          <BaseText style={[styles.fileName, { color: textColor }]}>{fileName}</BaseText>
          {isEditable && (
            <TouchableOpacity style={styles.removeButton} onPress={removeReceipt}>
              <Icon name="cancel" size={20} color={Color.primary} />
            </TouchableOpacity>
          )}
        </View>
      )}
    </TouchableOpacity>
  );
};

const h2 = scale(19.2);

const styles = StyleSheet.create({
  fileButtonContainer: {
    ...CommonProperties.row,
    ...CommonProperties.centerAlignment,
    borderRadius: scale(20),
    ...CommonProperties.p3,
    margin: 5,
  },
  addReceiptButtonContainer: {
    paddingHorizontal: scale(12),
    borderColor: Color.primary,
    borderWidth: 1,
  },
  fileName: {
    flex: 1,
    fontSize: h2 - scale(3.2),
  },
  removeButton: {
    marginLeft: 10,
  },
});
